// import classNames from 'clsx';
// import styles from './embed.module.less';
import type { VideoEmbedADT } from '../../type';

export function bilibili(input: VideoEmbedADT): VideoEmbedADT {
  // 已经被上游处理过就直接原样输出
  if (!(input instanceof URL)) return input;
  // const host = input.host;

  // if (host === 'www.bilibili.com') {
  //   const pathname = input.pathname;
  //   const bvid = pathname.match(/\/video\/BV(.*)/)?.[1];
  //   if (!bvid) return input;
  //   return (
  //     <div className={classNames('w-full h-full', styles.iframeEmbed)}>
  //       <iframe
  //         src={`//player.bilibili.com/player.html?aid=90263035&bvid=BV${bvid}`}
  //         scrolling="no"
  //         width="100%"
  //         // border="0"
  //         frameBorder="no"
  //         // framespacing="0"
  //         allowFullScreen
  //       />
  //     </div>
  //   );
  // }

  return input;
}
